<template>
  <div class="manage-home">
    <common-layout>
      <div slot="header">
        <h3>工作台</h3>
      </div>
      <div slot="container">
        <div class="manage-home.dashboard">
          <div class="manage-home.dashboard.header">
            <h3>
              <span>
                <i class="fa fa-home"></i>
              </span>
              <span>网站数据统计</span>
            </h3>
          </div>
          <div class="manage-home.row">
            <div class="manage-home.content +content-one">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">用户访问</font>
                  <i class="fa fa-line-chart"></i>
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ totalArr[0] }}</font>
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">次</font>
                  </font>
                </h6>
              </div>
            </div>

            <div class="manage-home.content +content-two">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">科技资源</font>
                  <i class="fa fa-bar-chart"></i>
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ totalArr[1] }}</font>
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">项</font>
                  </font>
                </h6>
              </div>
            </div>

            <div class="manage-home.content +content-three">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">平台服务</font>
                  <i class="fa fa-spinner"></i>
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ totalArr[2] }}</font>
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">次</font>
                  </font>
                </h6>
              </div>
            </div>
            <div class="manage-home.content +content-four">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">今日访问次数</font>
                  <!-- <i class="fa fa-spinner"></i> -->
                  <img src="../assets/all.png" alt="" srcset="" style="width: 25px;" />
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ tempData || 225 }}</font>
                    <!--<font style="vertical-align: inherit;">{{ totalArr[3] }}</font>-->
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">次</font>
                  </font>
                </h6>
              </div>
            </div>
            <div class="manage-home.content +content-five">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">累计登录次数</font>
                  <!-- <i class="fa fa-spinner"></i> -->
                  <img src="../assets/num.png" alt="" srcset="" style="width: 25px;" />
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ 21258 }}</font>
                    <!--<font style="vertical-align: inherit;">{{ totalArr[5] + 50 }}</font>-->
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">次</font>
                  </font>
                </h6>
              </div>
            </div>
            <div class="manage-home.content +content-six">
              <div class="manage-home.body">
                <img src="../assets/circle.svg" class="card-img-absolute" alt="圆像" />
                <h4 class="font-weight-normal mb-3">
                  <font style="vertical-align: inherit;">有效注册用户数</font>
                  <i class="fa fa-user"></i>
                </h4>
                <h2 class="mb-5">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{ totalArr[5] }}</font>
                  </font>
                </h2>
                <h6 class="card-text">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">个</font>
                  </font>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <!--每日登录次数先隐藏-->
        <!--<div style="height: 400px">-->
        <!--  <div style="display: flex;align-items: center;justify-content: flex-end">-->
        <!--    <el-date-picker-->
        <!--      v-if="searchTypeValue === 1"-->
        <!--      v-model="searchValueByYear"-->
        <!--      type="year"-->
        <!--      value-format="yyyy"-->
        <!--      @change="changeSearch"-->
        <!--      placeholder="选择年">-->
        <!--    </el-date-picker>-->
        <!--    <el-date-picker-->
        <!--      v-if="searchTypeValue === 2"-->
        <!--      v-model="searchValueByMonth"-->
        <!--      type="month"-->
        <!--      @change="changeSearch"-->
        <!--      value-format="yyyy-MM"-->
        <!--      placeholder="选择月">-->
        <!--    </el-date-picker>-->
        <!--    <el-select v-model="searchTypeValue" placeholder="请选择" style="margin-left: 20px">-->
        <!--      <el-option-->
        <!--        v-for="item in searchType"-->
        <!--        :key="item.value"-->
        <!--        :label="item.label"-->
        <!--        :value="item.value">-->
        <!--      </el-option>-->
        <!--    </el-select>-->
        <!--  </div>-->
        <!--  <people-count-bar-chart ref="refPeopleChart" :options="chartData"></people-count-bar-chart>-->
        <!--</div>-->
        <div class="manage-home.table">
          <section class="manage-home.preview">
            <div class="manage-home.register">
              <h3>最近注册</h3>
              <div class="timeLine" v-if="eventArr.length">
                <div class="event" v-for="(item, index) in eventArr" :key="index">
                  <div class="label">
                    <img
                      :src="item.image ? imgUrl + item.image : require('../assets/user-1.png')"
                      alt="标签图像"
                    />
                  </div>
                  <div class="content">
                    <div class="summary">
                      <a class="user">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{ item.username }}</font>
                        </font>
                      </a>
                      <!-- <font style="vertical-align: inherit;">
            	          <font style="vertical-align: inherit;">{{item.sitename}}</font>
            	        </font> -->
                      <div class="date">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{ item.register_time }}</font>
                        </font>
                      </div>
                    </div>
                    <!-- <div class="extra images">
											<a><img :src="item.siteimg" alt="背景图像"></a>
            	      </div>-->
                    <div class="meta">
                      <a class="item go">已注册</a>
                      <a class="item unGo" v-show="item.person_validate == 2">个人认证</a>
                      <a class="item like" v-show="item.company_validate == 2">企业认证</a>
                    </div>
                  </div>
                </div>
              </div>
              <p v-else>暂无数据</p>
            </div>
            <div style="margin-top:20px;" class="manage-home.register">
              <h3>机器人注册</h3>
              <div class="timeLine" v-if="robotArr.length">
                <div class="event" v-for="(item, index) in robotArr" :key="index">
                  <div class="label">
                    <img
                      :src="item.image ? imgUrl + item.image : require('../assets/user-1.png')"
                      alt="标签图像"
                    />
                  </div>
                  <div class="content">
                    <div class="summary">
                      <a class="user">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{ item.username }}</font>
                        </font>
                      </a>
                      <!-- <font style="vertical-align: inherit;">
            	          <font style="vertical-align: inherit;">{{item.sitename}}</font>
            	        </font> -->
                      <div class="date">
                        <font style="vertical-align: inherit;">
                          <font style="vertical-align: inherit;">{{ item.register_time }}</font>
                        </font>
                      </div>
                    </div>
                    <!-- <div class="extra images">
											<a><img :src="item.siteimg" alt="背景图像"></a>
            	      </div>-->
                    <div class="meta">
                      <a class="item go">已注册</a>
                      <a class="item unGo" v-show="item.person_validate == 2">个人认证</a>
                      <a class="item like" v-show="item.company_validate == 2">企业认证</a>
                    </div>
                  </div>
                </div>
              </div>
              <p v-else>暂无数据</p>
            </div>
          </section>
          <section class="manage-home.tips">
            <div class="manage-home.actiity">
              <h3>资源发布</h3>
              <div v-if="tableData">
                <el-table :data="tableData" style="width: 100%;" :header-cell-style="headerStyle">
                  <el-table-column prop="moudle" label="所属模块" align="center"></el-table-column>
                  <el-table-column prop="name" label="名称" align="center"></el-table-column>
                  <el-table-column prop="date_time" label="时间" align="center"></el-table-column>
                </el-table>
              </div>
              <p v-else>暂无数据</p>
            </div>
          </section>
          <section class="manage-home.service">
            <div class="manage-home.suggest">
              <h3>活动动向</h3>
              <ul v-if="messageData.length">
                <li v-for="(item, index) in messageData" :key="index">
                  <!-- <a href="#"> -->
                  <img :src="imgUrl + item.image" />
                  <p>
                    <span>
                      {{ item.active_name }}
                    </span>
                    <span style="color:#368ee0">
                      {{ item.enroll_name }}
                      <a class="item go" v-show="item.date_type == 1">已报名</a>
                      <a class="item like" v-show="item.date_type == 2">已签到</a>
                    </span>
                  </p>
                  <span class="date">{{ item.date_time ? item.date_time.slice(0, 10) : '' }}</span>
                  <!-- </a> -->
                </li>
              </ul>
              <p v-else>暂无数据</p>
            </div>
            <div class="manage-home.suggest">
              <h3>场地预约</h3>
              <ul v-if="meetingData.length">
                <li v-for="(item, index) in meetingData" :key="index">
                  <!-- <a href="#"> -->
                  <!-- <img :src="imgUrl + item.image" /> -->
                  <p>
                    <span>
                      {{ item.field_name }}
                    </span>
                    <span style="color:#368ee0">
                      {{ item.people }}
                      <a class="item go" v-show="item.status == 1">已通过</a>
                      <a class="item unGo" v-show="item.status == 2">未通过</a>
                      <a class="item qu" v-show="item.status == 3">已取消</a>
                      <a class="item like" v-show="item.status == 4">待审核</a>
                    </span>
                  </p>
                  <span class="date">
                    {{ item.create_time ? item.create_time.slice(0, 10) : '' }}
                  </span>
                  <!-- </a> -->
                </li>
              </ul>
              <p v-else>暂无数据</p>
            </div>
            <div class="manage-home.suggest" v-show="this.skillData.length">
              <h3>事项办理</h3>
              <ul v-if="skillData.length">
                <li v-for="(item, index) in skillData" :key="index">
                  <!-- <a href="#"> -->
                  <!-- <img :src="imgUrl + item.image" /> -->
                  <p>
                    <span>
                      {{ item.skillName }}
                    </span>
                    <span style="color:#368ee0">
                      {{ item.contact }}
                      <a class="item go" v-show="item.status == 1">已通过</a>
                      <a class="item unGo" v-show="item.status == 2">未通过</a>
                      <a class="item like" v-show="item.status == 3">待审核</a>
                    </span>
                  </p>
                  <span class="date">{{ item.date_time ? item.date_time.slice(0, 10) : '' }}</span>
                  <!-- </a> -->
                </li>
              </ul>
              <p v-else>暂无数据</p>
            </div>
          </section>
        </div>
      </div>
    </common-layout>
  </div>
</template>

<script>
// @ is an alias to /src
// import Swiper from "swiper";
// import "swiper/dist/css/swiper.min.css";
import urlConfig from '../url'

import CommonLayout from '../components/common-layout.vue'
import PeopleCountBarChart from '@/components/people-count-bar-chart.vue'

export default {
  name: 'home',
  components: {
    PeopleCountBarChart,
    CommonLayout
  },
  data() {
    return {
      tempData:0,
      chartData:{
        xData:[],
        yData:[]
      },
      searchTypeValue: 2, // 先默认月
      searchType: [
        { label: '按年查看', value: 1 },
        { label: '按月查看', value: 2 }
      ],
      searchValueByYear: '2024',
      searchValueByMonth: '2024-09',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      totalArr: [],
      eventArr: [],
      robotArr: [],
      tableData: [],
      messageData: [],
      meetingData: [],
      skillData: [],
      skill: ['技术贸易资格证新办', '技术贸易资格证年检', '技术合同认定', '技术经纪(经理)人培训'],
      meeting: [],
      interval: ''
    }
  },
  created() {
    // this.getRobotRegister()
  },
  mounted() {
    this.getMeeting()
    this.changeSearch()
    this.interval = setInterval(() => {
      this.getMeeting()
    }, 10000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    changeSearch() {
      let data = {
        type: this.searchTypeValue,
        key: this.searchTypeValue === 1 ? this.searchValueByYear : this.searchValueByMonth
      }
      console.log('data', data)
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/loginCount/count`, data).then(
        (response) => {
          if (response.code === 0) {
            console.log('response', response)
            this.chartData.xData = [];
            this.chartData.yData = [];
            if(response.data?.length > 0) {
              response.data.forEach(item => {
                const { createDate, countNum } = item;
                this.chartData.xData.push(createDate);
                this.chartData.yData.push(countNum);
              });
            }
            this.tempData = response.data[response.data.length - 1].countNum || 225
            console.log('this.chartData',this.chartData)
          } else {
            this.$message.error(response.status)
          }
        },
        (error) => {
        }
      )
    },
    getMeeting() {
      this.http.get('Meeting_Field?is_can=1').then(res => {
        if (res.code == 0) {
          this.meeting = res.data.data
          this.getTotal()
        }
      })
    },
    // getRobotRegister() {
    //   this.http.get('/User?page=1&serial_numbers=MQ1139K291FA0,MQ1149C32J93B&page_size=10').then(res => {
    // this.robotArr = res.data.data;
    //   })
    // },
    getTotal() {
      this.http.get('Index_Manage').then(res => {
        if (res.code == 0) {
          this.totalArr.push(res.data.YHFW)
          this.totalArr.push(res.data.KJZY)
          this.totalArr.push(res.data.PTFU)
          this.totalArr.push(res.data.JRDL)
          this.totalArr.push(res.data.LSDL)
          this.eventArr = res.data.RZ.data
          this.robotArr = res.data.ROBOT_RZ.data

          this.messageData = res.data.BMQD
          this.skillData = res.data.BLSX.data
          res.data.YY.data.forEach(item => {
            this.meeting.forEach(ele => {
              if (ele.id == item.field_id) {
                item.field_name = ele.field_name
                item.image = ele.image
              }
            })
          })
          this.meetingData = res.data.YY.data
          this.skillData.forEach(ele => {
            ele.skillName = this.skill[ele.type - 1]
          })
          this.tableData = res.data.KJZY_NEW.data

          this.http.get('apij2/admin-api/system/user/activeRegistrants').then(response => {
            this.totalArr.push(response.data)
          })
        }
      })
    },
    getClass(type) {
      if (type == 2) {
        return 'go'
      }
      if (type == 1) {
        return 'unGo'
      }
      return 'like'
    }
  }
}
</script>

<style lang="scss">
@include component(manage-home) {
  height: 100%;

  @include part(dashboard) {
    width: 100%;

    @include part(header) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 15px;

      h3 {
        font-size: 18px;
        display: flex;
        align-items: center;
        margin: 0;

        span {
          display: inline-block;

          &:nth-child(1) {
            display: inline-block;
            width: 36px;
            height: 36px;
            line-height: 36px;
            border-radius: 4px;
            text-align: center;
            box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);
            background: linear-gradient(to right, #da8cff, #9a55ff);
            color: #fff;
          }

          &:nth-child(2) {
            margin-left: 10px;
          }
        }
      }
    }
  }

  @include part(row) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
  }

  @include part(content) {
    width: calc(100% / 3 - 30px);
    margin: 0 15px 30px;
    height: 220px;
    position: relative;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    background-clip: border-box;
    border-radius: 10px;
  }

  @include part(body) {
    padding: 40px;
    color: #fff;

    > img {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
    }

    > h4,
    h2,
    h6 {
      margin: 0;
      text-align: left;
    }

    h4 {
      font-size: 18px;
      font-weight: normal;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    h2 {
      font-size: 30px;
      margin-bottom: 48px;
    }

    h6 {
      font-size: 14px;
      font-weight: normal;
    }
  }

  @include part(table) {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    > section {
      width: calc(100% / 3 - 30px);
      // height: 698px;
      // background: #f0f0f0;
      border-radius: 10px;
      padding: 20px;

      &:nth-of-type(1) {
        padding: 0;
      }

      h3 {
        margin: 0;
        text-align: left;
      }
    }
  }

  @include part(register) {
    background: #f0f0f0;
    padding: 20px;

    padding-bottom: 30px;
    border-radius: 10px;
    h3 {
      border-bottom: 1px solid rgba(34, 36, 38, 0.15);
      padding-bottom: 10px;
    }

    .timeLine {
      max-height: 400px;
      overflow: auto;
      margin-top: 12px;
      margin-left: 15px !important;
      position: relative;
      padding-bottom: 10px;

      &:after {
        content: '';
        width: 16px;
        height: 16px;
        border: 2px solid #ccc;
        position: absolute;
        left: 2px;
        border-radius: 50%;
        background: #307473;
        margin-bottom: 10px;
      }

      .event {
        border-left: 1px solid #307473;

        margin-left: 10.5px !important;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-direction: row;
        // width: 100%;
        padding: 2.571px 0 2.571px 10px;

        background: 0 0;
        border-top: none;

        &:nth-child(1) {
          padding-top: 0;
          border-top: 0;
        }
      }

      .label {
        display: block;
        flex: 0 0 auto;
        width: 40px;
        height: auto;
        align-self: stretch;
        text-align: left;

        > img {
          display: block;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #fff;
          object-fit: cover;
        }
      }

      .content {
        display: block;
        flex: 1 1 auto;
        align-self: stretch;
        text-align: left;
        word-wrap: break-word;
        margin: 6px 0 4.3px 14px;

        .summary {
          margin: 0;
          font-size: 1em;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.87);

          .user {
            display: inline-block;
            font-weight: 700;
            margin-right: 5px;
            vertical-align: baseline;
            color: #4183c4;
          }

          .date {
            float: none;
            display: inline-block;
            font-weight: 400;
            font-size: 0.85714286em;
            font-style: normal;
            margin: 0 0 0 0.5em;
            padding: 0;
            color: rgba(0, 0, 0, 0.4);
          }
        }

        .meta {
          display: inline-block;
          font-size: 0.85714286em;
          margin: 0.5em 0 0;
          background: 0 0;
          border: none;
          border-radius: 0;
          box-shadow: none;
          padding: 0;
          color: rgba(0, 0, 0, 0.6);

          .item {
            display: inline-block;
            color: #ffffff;
            padding: 3px 6px;
            border-radius: 3px;
            margin-right: 10px;
          }

          .like {
            background: linear-gradient(to right, #90caf9, #047edf 99%);
          }

          .unGo {
            background: linear-gradient(to right, #ffbf96, #fe7096);
          }

          .go {
            background: linear-gradient(to right, #84d9d2, #07cdae);
          }
        }

        .extra {
          margin: 6px 0 0;
          background: 0 0;
          padding: 0;
          color: rgba(0, 0, 0, 0.87);

          img {
            display: inline-block;
            margin: 0 3px 0 0;
            width: 72px;
          }
        }
      }
    }
  }

  @include part(tips) {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  @include part(news) {
    width: 100%;
    height: 283px;
    background: #f0f0f0;
    border-radius: 10px;
    padding: 20px;

    > ul {
      width: 100%;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        cursor: pointer;

        &:not(:nth-of-type(1)) {
          margin-top: 15px;
        }

        i {
          display: flex;
          width: 30px;
          height: 30px;
          border: 1px solid lightgrey;
          border-radius: 50%;
          color: #db2828;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          font-size: 16px;
        }

        a {
          position: absolute;
          right: 0;
          border: 1px solid #db2828;
          padding: 2px 10px;
          color: #db2828;
          border-radius: 5px;
        }
      }
    }
  }

  @include part(actiity) {
    width: 100%;
    // margin-top: 20px;
    // height: 395px;
    background: #f0f0f0;
    border-radius: 10px;
    padding: 20px;
    > div {
      height: 100%;
      padding-top: 10px;
      overflow: hidden;
    }
    .el-table th,
    .el-table tr {
      background: #e1e1e1;
      padding: 0 !important;
    }
    .el-table td,
    .el-table th {
      height: 50px !important;
      padding: 0 !important;
    }
  }

  @include part(service) {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
  @include part(suggest) {
    width: 100%;
    margin-bottom: 20px;
    // height: 395px;
    background: #f0f0f0;
    border-radius: 10px;
    padding: 20px;
    h3 {
      margin: 0;

      small {
        display: inline-block;
        padding: 2px 5px;
        background: #ef4836;
        color: #fff;
        font-weight: normal;
        border-radius: 5px;
        margin-left: 5px;
      }
    }
    > ul {
      // display: flex;
      // flex-direction: column;
      margin-top: 10px;
      max-height: 200px;
      overflow: auto;

      li {
        border-bottom: 1px solid rgba(0, 0, 0, 0.09);

        // a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #76747a;
        position: relative;
        font-size: 12px;
        text-decoration: none;

        > img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
          object-fit: cover;
        }

        > p {
          width: calc(100% - 120px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 20px;

          i {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #27ae60;
            border-radius: 50%;
            margin-right: 5px;
          }

          span {
            font-weight: 700;
          }
        }

        a {
          display: inline-block;
          color: #ffffff;
          padding: 3px 6px;
          border-radius: 3px;
          margin-left: 10px;
        }

        .like {
          background: linear-gradient(to right, #90caf9, #047edf 99%);
        }

        .unGo {
          background: linear-gradient(to right, #ffbf96, #fe7096);
        }

        .go {
          background: linear-gradient(to right, #84d9d2, #07cdae);
        }

        .qu {
          background: linear-gradient(to right, #eee, #000);
        }

        .date {
          width: 80px;
          text-align: center;
        }

        // }
      }
    }
  }
  @include part(message) {
    width: 100%;
    height: 283px;
    background: #f0f0f0;
    border-radius: 10px;
    padding: 20px;
    h3 {
      margin: 0;

      small {
        display: inline-block;
        padding: 2px 5px;
        background: #f39c12;
        color: #fff;
        font-weight: normal;
        border-radius: 5px;
        margin-left: 5px;
      }
    }
    > ul {
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      li {
        width: 100%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.09);
        padding-bottom: 20px;

        &:not(&:nth-child(1)) {
          margin-top: 15px;
        }

        a {
          text-decoration: none;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            display: block;
            border-radius: 50%;
            border: 1px solid #368ee0;
          }
        }

        div {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 10px;
          width: 100%;
          cursor: pointer;

          > p {
            width: 100%;
            margin: 0;
            display: flex;
            justify-content: space-between;

            span {
              color: #368ee0;
              font-size: 13px;
              font-weight: bold;

              &.time {
                color: #222222;
                font-size: 12px;
                font-weight: normal;
              }

              &.name {
                margin: 0 5px;
              }
            }
          }

          > span {
            color: #919292;
            font-size: 13px;
            text-align: left;
          }
        }
      }
    }
  }

  @include tweak(content-one) {
    background: linear-gradient(to right, #ffbf96, #fe7096);
  }

  @include tweak(content-two) {
    background: linear-gradient(to right, #90caf9, #047edf 99%);
  }

  @include tweak(content-three) {
    background: linear-gradient(to right, #84d9d2, #07cdae);
  }
  @include tweak(content-four) {
    background: linear-gradient(to right, #fbbd61, #e67450);
  }
  @include tweak(content-five) {
    background: linear-gradient(to right, #a0f5ff, #1a7db0);
  }
  @include tweak(content-six) {
    background: linear-gradient(to right, #da8cff, #9a55ff);
  }
}
</style>
